/* eslint-disable no-dupe-keys */
export default {
  virtual_user: {
    name: '虚拟用户',
    // 属性（一般与对象内容匹配）
    prop: {
      nick_name: '昵称',
      service_provider: '运营商',
      group_balance: '运营商专属余额',
      allow_ev_charging_stations: '开放站',
      allow_periods: '开放时间',
      last_charge_at: '最近充电时间',
      magcards: '磁卡',
      webapp_login_url: 'App入口',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询 用户昵称/编号/磁卡'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      orders: '订单记录',
      order_statistics: '订单统计',
      transaction_records: '账单'
    },
    titles: {
      base_info: '基本信息',
      condition_info: '约束条件',
      magcard_info: '磁卡信息'
    },
    validates: {
      periods_has_intersaction: '时间段存在交集'
    },
    btn: {
      virual_user_order: '虚拟用户订单'
    }
  }
}
